var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EIcon',{class:_vm.componentClass,attrs:{"name":_vm.logos[_vm.currentRoute] ? _vm.logos[_vm.currentRoute] : 'OK',"width":"80"}})
}
var staticRenderFns = []

export { render, staticRenderFns }